var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBinocular(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2334 7.25033H23.4112V5.26303C23.5 0.579241 23 4.61848 22 4.61849L18.0618 4.61849C17.5357 4.61849 17.2334 4.81538 17.2334 5.26303V7.25033Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7666 21.4404H3.00003V23.3848C3.00003 23.7407 3.28861 24.0293 3.64456 24.0293H10.1221C10.4781 24.0293 10.7666 23.7407 10.7666 23.3848V21.4404Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2334 21.4404V23.3848C17.2334 23.7407 17.522 24.0293 17.878 24.0293H24.3555C24.7115 24.0293 25 23.7407 25 23.3848V21.4404H17.2334Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7666 20.1514V8.53906H4.40709L3.5 15.5789C3 19.0789 3 20.1514 3 20.1514H10.7666Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2334 20.1514V8.53906H23.5929L24.5 15.5789C25 19.0789 25 20.1514 25 20.1514H17.2334Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9444 11.085V9.7959H12.0557V11.085V18.8516H15.9444V11.085ZM13.3555 15.6182V13.0293C13.3555 12.6733 13.6441 12.3848 14 12.3848C14.356 12.3848 14.6446 12.6733 14.6446 13.0293V15.6182C14.6446 15.9741 14.356 16.2627 14 16.2627C13.6441 16.2627 13.3555 15.9741 13.3555 15.6182Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7666 7.25031V5.26301C10.7666 4.8903 10.4643 4.61847 9.87371 4.61847L6.00003 4.61846C4.99994 4.61848 4.50002 0.579222 4.5889 5.26301V7.25031H10.7666Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinocular);
export default __webpack_public_path__ + "static/media/binocular.06e8b78e061f7b5d0b311202d4d3cbb1.svg";
export { ForwardRef as ReactComponent };